import { Stack, StackProps, Tooltip, Typography, TypographyProps, styled } from '@mui/material'
import isNil from 'lodash/isNil'
import { useTranslation } from 'react-i18next'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { InitialsAvatar } from '@omnea-app/fe-users-and-groups/avatar/InitialsAvatar'

export interface Props extends StackProps {
  text: string
  imgUrl?: string | null
  avatarVariant?: 'square' | 'rounded' | 'circular'
  tooltipLabel?: string
  disableTooltip?: boolean
  userId: string | null
  textProps?: TypographyProps
  isArchived?: boolean
}

const StyledAvatar = styled(InitialsAvatar)(() => ({
  lineHeight: '25px',

  '& .MuiAvatar-img': {
    objectFit: 'contain',
  },
}))

export const ProfileBox = ({
  text,
  imgUrl,
  tooltipLabel,
  avatarVariant = 'rounded',
  disableTooltip = false,
  userId,
  textProps,
  isArchived,
  ...stackProps
}: Props) => {
  const { user: loggedInUser } = useAuthenticatedUser()
  const { t: tCommon } = useTranslation('common')
  const isLoggedInUser = loggedInUser?.id === userId
  const isUserAvatar = !isNil(userId)
  const styleOverrideProps = isLoggedInUser || !isUserAvatar ? {} : { sx: { backgroundColor: ' grey' } }

  const displayText = isArchived ? `${text} ${tCommon('archived')}` : text

  return (
    <Tooltip title={!disableTooltip ? tooltipLabel || text : ''}>
      <Stack
        direction="row"
        spacing={2}
        {...stackProps}
        sx={{ alignItems: 'center', overflow: 'hidden', textOverflow: 'ellipsis', ...stackProps.sx }}
      >
        <StyledAvatar
          alt={text}
          src={imgUrl ? imgUrl.replace('http://', 'https://') : undefined}
          variant={avatarVariant}
          fullName={text}
          {...styleOverrideProps}
        />
        <Typography variant="Body14pxRegular" noWrap {...textProps} {...(isArchived && { color: 'error.dark' })}>
          {displayText}
        </Typography>
      </Stack>
    </Tooltip>
  )
}
